// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Ch0W","title":"styles_title__8USUc","text_with_title":"styles_text_with_title__exkNC"};